var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSidebarTheory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0BD83142-83EC-4AA3-B17F-FF3F965D0155") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.8,3 C8.10213067,3 9.23902135,3.68591277 10.0004008,4.75368797 C10.7609786,3.68591277 11.8978693,3 13.2,3 L18,3 C18.5522847,3 19,3.44771525 19,4 L19,16 C19,16.5522847 18.5522847,17 18,17 L14,17 C12.732585,17 11.7419941,17.4556887 10.9547577,18.403801 L10.8356665,18.557314 C10.7854275,18.6323633 10.7254288,18.6989832 10.6581771,18.756338 L10.6067403,18.7973635 C10.4251234,18.9398059 10.2113104,19.0039655 10.0000529,19.0019492 C9.83150186,19.0037123 9.66070322,18.9630283 9.50585899,18.8739186 L9.37706989,18.7850399 L9.3425777,18.7558211 C9.27278598,18.6974606 9.21139223,18.6288198 9.16035334,18.5513195 C8.35587712,17.502154 7.3304641,17 6,17 L2,17 C1.44771525,17 1,16.5522847 1,16 L1,4 C1,3.44771525 1.44771525,3 2,3 L6.8,3 Z M6.8,5 L3,5 L3,15 L6,15 C7.03788875,15 7.97927867,15.2235786 8.8113549,15.6643283 L9,15.769 L9,8 L8.99543615,7.80569766 C8.92283364,6.2662833 7.99408533,5.09681355 6.93324115,5.00571903 L6.8,5 Z M17,5 L13.2,5 C12.0401886,5 11,6.30023575 11,8 L11,15.769 L11.1886451,15.6643283 C11.945078,15.2636468 12.7918529,15.0424455 13.7193416,15.0055385 L14,15 L17,15 L17,5 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "S\\u0101kums",
    transform: "translate(-20.000000, -115.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    transform: "translate(0.000000, 61.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(0.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(20.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Sidebar-/-Theory",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "viewbox",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon",
    fill: "#667380",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Icon-color",
    fill: "#A7A9AD",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSidebarTheory);
export default __webpack_public_path__ + "static/media/ic-sidebar-theory.b7cac30079cab79cdc36589f49e77452.svg";
export { ForwardRef as ReactComponent };